export const getSubjectData = (subjectId) => {
    try {
        const allData = JSON.parse(localStorage.getItem('subjectData') || '{}');
        return subjectId ? (allData[subjectId] || {}) : allData;
    } catch (error) {
        console.error('Error parsing subject data:', error);
        return subjectId ? {} : {};
    }
};

export const setSubjectData = (subjectId, taskName, data) => {
    if (!subjectId) {
        console.error('No subject ID provided for storage');
        return;
    }
    
    try {
        const allData = JSON.parse(localStorage.getItem('subjectData') || '{}');
        
        if (!allData[subjectId]) {
            allData[subjectId] = {};
        }
        
        // Make a deep copy to avoid reference issues
        const dataCopy = JSON.parse(JSON.stringify(data));
        
        // Check if existing data is more recent
        const existingData = allData[subjectId][taskName] || {};
        if (existingData.timeLastModified && dataCopy.timeLastModified) {
            const existingTime = new Date(existingData.timeLastModified);
            const newTime = new Date(dataCopy.timeLastModified);
            
            // If existing data is more recent, preserve it and only update non-critical fields
            if (existingTime > newTime) {
                console.log(`Existing data for ${taskName} is more recent, preserving it`);
                // Only update fields that don't contain user input
                const preservedData = {
                    ...dataCopy,
                    entries: existingData.entries || dataCopy.entries,
                    administeringNotes: existingData.administeringNotes || dataCopy.administeringNotes,
                    scoringNotes: existingData.scoringNotes || dataCopy.scoringNotes,
                    entrySummary: existingData.entrySummary || dataCopy.entrySummary,
                    timeLastModified: existingData.timeLastModified
                };
                allData[subjectId][taskName] = preservedData;
            } else {
                // New data is more recent, use it
                allData[subjectId][taskName] = {...existingData, ...dataCopy};
            }
        } else {
            // No timestamp comparison possible, merge normally
            allData[subjectId][taskName] = {...existingData, ...dataCopy};
        }
        
        // For certain tasks, also store under alternative keys for compatibility
        if (taskName === 'verbalFluencyLetterFData') {
            allData[subjectId]['letterFData'] = allData[subjectId][taskName];
        } else if (taskName === 'letterFData') {
            allData[subjectId]['verbalFluencyLetterFData'] = allData[subjectId][taskName];
        } else if (taskName === 'verbalFluencySupermarketData') {
            allData[subjectId]['supermarketData'] = allData[subjectId][taskName];
        } else if (taskName === 'supermarketData') {
            allData[subjectId]['verbalFluencySupermarketData'] = allData[subjectId][taskName];
        } else if (taskName === 'clockDrawingData') {
            // Ensure clockDrawingScore is properly set
            if (dataCopy.scoringNotes && !dataCopy.clockDrawingScore) {
                dataCopy.clockDrawingScore = dataCopy.scoringNotes;
                allData[subjectId][taskName].clockDrawingScore = dataCopy.scoringNotes;
            }
        }
        
        localStorage.setItem('subjectData', JSON.stringify(allData));
        console.log(`Saved data for ${taskName}:`, allData[subjectId][taskName]);
        
        // Return the updated data
        return allData[subjectId][taskName];
    } catch (error) {
        console.error('Error saving subject data:', error);
        return null;
    }
};
